import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CompanyDialog } from "@/components/MasterForms";
import { useStore } from "@/store/AppStore";
import { PageHeader, ProgressLine, Tag, attTone } from "@/components/kit";
import { companySummary } from "@/lib/selectors";
import { brl } from "@/lib/format";

const Stat = ({ label, value }) => (
  <div>
    <p className="text-[10px] uppercase tracking-widest text-neutral-400">{label}</p>
    <p className="mt-1 text-sm font-semibold text-neutral-900">{value}</p>
  </div>
);

export default function MasterCompanies() {
  const { state } = useStore();
  return (
    <div data-testid="master-companies-page">
      <PageHeader eyebrow="Carteira de clientes" title="Empresas atendidas" subtitle="Selecione uma empresa para ver processos, equipe, tarefas e metas." actions={<CompanyDialog testId="new-company" trigger={<Button className="font-semibold" data-testid="new-company-button"><Plus className="mr-1.5 h-4 w-4" /> Nova empresa</Button>} />} />
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {state.companies.map((c) => {
          const r = companySummary(state, c);
          return (
            <Link key={c.id} to={`/master/empresas/${c.id}`} data-testid={`company-card-${c.id}`} className="group rounded-xl border border-neutral-200 bg-white p-7 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-[transform,box-shadow,border-color] duration-200 hover:-translate-y-1 hover:border-gold hover:shadow-md">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <Tag tone="gold">{c.segment}</Tag>
                  <h3 className="mt-4 font-display text-2xl font-semibold text-neutral-900">{c.name}</h3>
                  <p className="mt-1 flex items-center gap-1 text-xs text-neutral-500"><MapPin className="h-3 w-3" /> {c.city} · desde {c.since}</p>
                </div>
                <ArrowUpRight className="h-5 w-5 text-neutral-300 transition-colors group-hover:text-gold" />
              </div>
              <div className="mt-6 flex items-center gap-3"><ProgressLine value={r.att} /><Tag tone={attTone(r.att)}>{r.att}%</Tag></div>
              <div className="mt-6 grid grid-cols-2 gap-4 border-t border-neutral-100 pt-5 sm:grid-cols-4">
                <Stat label="Vendas" value={brl(r.sales)} />
                <Stat label="Equipe" value={r.team} />
                <Stat label="Tarefas" value={`${r.taskRate}%`} />
                <Stat label="Atrasadas" value={r.overdue} />
              </div>
              <p className="mt-5 text-xs text-neutral-500">Empresária: <span className="font-semibold text-neutral-800">{c.owner}</span></p>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
